import Button from "./button";
import { useRef } from "react";

const SecondaryButton = ({ children, handleClick, ...props }) => {
if (
    process.env.NODE_ENV !== "production" &&
    children.type?.name !== "ButtonContent"
  ) {
    throw new Error(
      "Button component only accepts ButtonContent component as children"
    );
  }

  const buttonRef = useRef(null);

  return (
    <button
      onClick={handleClick}
      type={props.type}
      ref={buttonRef}
      className={`!w-full !py-[7.73px] hover:custom-bg-white-200 !px-[15.45px] !rounded-[6.182px] !text-[12px] text-center justify-center poppins-regular !mt-0 !custom-text-grey-900 !custom-bg-white-50 ${props.className} ${props.additionalclasses || ""}`}
      {...props}
    >
      {children}
    </button>
  );
};

SecondaryButton.defaultProps = {
  additionalclasses: "",
};
export default SecondaryButton;
